export default "__VITE_ASSET__b4wT9Pfx__"